import { Component } from '@angular/core';

@Component({
  selector: 'hot-tea-loading',
  templateUrl: './hot-tea-loading.component.html',
  styleUrls: ['./hot-tea-loading.component.scss'],
  standalone: false,
})
export class HotTeaLoadingComponent {}
